import React, { useState, useMemo } from "react";

import { Box, Tabs, Tab } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { ReactComponent as WiredIcon } from "assets/images/icons/icn_dashboard_wired_status.svg";
import { ReactComponent as WiredNoStateIcon } from "assets/images/icons/icn_no_status.svg";
import SettingsDrawer from "./settings";
import GeneralDrawer from "./general";

import {
  calcVlanIdsCountByDevice
} from 'utils/validate';

const AccessPointsDrawer = ({
  auth,
  drawerOpen,
  setAlertInfo,
  activeRow,
  setActiveRow,
  accessPointsData,
  setAccessPointsData,
  originalRowData,
  setOriginalRowData,
  profileAPList,
  onUpdateBlockerData,
  initCallback,
  showEditGeneral,
}) => {
  const theme = useTheme();
  const [tabValue, setTabValue] = useState("general");

  const sameModelPorts = useMemo(() => accessPointsData.filter(loopPort => loopPort.modelName === activeRow.modelName), [accessPointsData, activeRow]);
  const vlanIdsCount = useMemo(() => calcVlanIdsCountByDevice(sameModelPorts, activeRow), [sameModelPorts, activeRow]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const ComposedIcon = (
    <Box
      sx={{
        position: "relative",
        width: 60,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <WiredIcon
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 1,
        }}
      />
      {activeRow?.state === "-" && (
        <WiredNoStateIcon
          style={{
            position: "absolute",
            zIndex: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      )}
      {activeRow?.state && activeRow.state !== "-" && (
        <Box
          sx={{
            position: "absolute",
            zIndex: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {activeRow.state}
        </Box>
      )}
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          paddingLeft: "25px",
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {activeRow && (
          <>
            {ComposedIcon}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              {activeRow && (
                <span
                  style={{
                    fontWeight: theme.typography.customFontWeight[3],
                    fontSize: theme.typography.customFontSize[5],
                    color: theme.palette.primary.greyPrimary,
                  }}
                >
                  {activeRow.portName}
                </span>
              )}
              {activeRow.portIndex && (
                <Box sx={{ display: "flex", gap: 1 }}>
                  Port {activeRow.portIndex}
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 2,
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{
            width: "90%",
            minHeight: "auto",
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.primary.main,
              height: "5px",
              borderRadius: theme.shape.customBorderRadius[0],
            },
            ".MuiTabs-flexContainer": {
              justifyContent: "space-between",
            },
          }}
        >
          {["general", "settings"].map((tab) => (
            <Tab
              key={tab}
              label={tab.charAt(0).toUpperCase() + tab.slice(1)}
              value={tab}
              sx={{
                minHeight: "auto",
                textTransform: "none",
                fontWeight:
                  tabValue === tab
                    ? theme.typography.customFontWeight[1]
                    : theme.typography.customFontWeight[0],
                color:
                  tabValue === tab
                    ? theme.palette.primary.main
                    : theme.palette.primary.greySecound,
                fontSize: theme.typography.customFontSize[3],
                flex: 1,
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ width: "100%", marginTop: 2 }}>
        {tabValue === "general" && (
          <GeneralDrawer
            key={activeRow?.id}
            auth={auth}
            activeRow={activeRow}
            setActiveRow={setActiveRow}
            setOriginalRowData={setOriginalRowData}
            initCallback={initCallback}
            showEditGeneral={showEditGeneral}
          />
        )}
        {tabValue === "settings" && (
          <SettingsDrawer
            key={activeRow?.id}
            drawerOpen={drawerOpen}
            setAlertInfo={setAlertInfo}
            activeRow={activeRow}
            setActiveRow={setActiveRow}
            originalRowData={originalRowData}
            setOriginalRowData={setOriginalRowData}
            accessPointsData={accessPointsData}
            setAccessPointsData={setAccessPointsData}
            onUpdateBlockerData={onUpdateBlockerData}
            profileAPList={profileAPList}
            showEditGeneral={showEditGeneral}
            vlanIdsCount={vlanIdsCount}
          />
        )}
      </Box>
    </>
  );
};
export default AccessPointsDrawer;
